module.exports = __webpack_public_path__ + "static/media/formImageCampaigns.d7697751.png";